import { Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import HomePage from './pages/HomePage';
import { PricingPage } from './pages/PricingPage';
import ProfilePage from './pages/ProfilePage';
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage';
import PurchaseSuccessPage from './pages/PurchaseSuccessPage';
import FinalizePage from './pages/FinalizePage';
import TermsPage from './pages/TermsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CookiesPage from './pages/CookiesPage';
import AboutPage from './pages/AboutPage';
import { GeneratorProvider } from './features/generator/context/GeneratorContext';
import Footer from './components/layout/Footer';
import CookieConsent from './components/ui/CookieConsent';
import { SentryUserContext } from './components/SentryUserContext';
import AdminPage from './pages/AdminPage';
import AdminRoute from './auth/AdminRoute';
import PostSignupModal from './components/ui/PostSignupModal';
import DesktopExperienceModal from './components/ui/DesktopExperienceModal';
function App() {
  return (
    <GeneratorProvider>
      <SentryUserContext />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 w-full relative">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/subscription/success" element={<SubscriptionSuccessPage />} />
            <Route path="/purchase/success" element={<PurchaseSuccessPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route path="/about" element={<AboutPage />} />

            <Route path="/admin" element={
              <AdminRoute>
                <AdminPage />
              </AdminRoute>
            } />
            <Route path="/finalize/:id" element={<FinalizePage />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <PostSignupModal />
        <DesktopExperienceModal />
      </div>
    </GeneratorProvider>
  );
}

export default App;
